module.exports = __webpack_public_path__ + "static/media/growing-new-farmers.0727b830.jpg";